module.exports = __webpack_public_path__ + "img/collection-engagementRingsWhitegold@2x.1fac907.webp";